import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(() => ({
  stickyHeader: {
    position: 'sticky',
    top: 115,
    background: 'white'
  },
  adminListViewWrapper: {
    marginTop: 45,
    paddingTop: 0,
    margin: '0 auto',
    paddingBottom: 100
  },
  usersHeader: {
    color: "black",
    fontSize: "35px !important",
    lineHeight: "50px",
    paddingBottom: '5px',
    textAlign: 'center'
  },
  tableCell: {
    padding: 15,
  }
}));